import { takeLatest } from 'redux-saga/effects';
import {
  doSNComputeSuccess, doSNComputeFail,
} from './toolState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, LOADING_MSG,
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/tools');

function* doSNCompute(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('sn-compute', data.payload), 
		doSNComputeSuccess, 
		doSNComputeFail, null, null, LOADING_MSG);
}

function* toolSaga() {
  yield takeLatest('tool/doSNCompute', doSNCompute);
}

export default toolSaga;
